{
  "eyebrow": "Fakturering og betaling",
  "title": "Nesten i mål.",
  "sub": "Fortsett til sikker kasse for å starte 30-dagers prøveperioden. Du belastes ikke i dag.",
  "summary": {
    "plan": "Abonnement",
    "cycle": "Faktureringssyklus",
    "users": "Brukere",
    "vtt": "Vehicle Track & Trace",
    "vehicles": "Kjøretøy",
    "total": "Estimert totalt / måned",
    "vttOn": "Inkludert"
  },
  "secureNote": "Sikker kasse via Stripe · 30 dagers prøveperiode · Avslutt når som helst",
  "continue": "Fortsett til Stripe",
  "submitting": "Åpner Stripe…",
  "canceled": {
    "title": "Betalingen ble avbrutt",
    "sub": "Ingen belastning ble gjort. Prøv igjen eller kontakt oss hvis du trenger hjelp.",
    "retry": "Prøv igjen"
  },
  "promo": {
    "toggle": "Har du en kampanjekode?",
    "placeholder": "Kampanjekode",
    "apply": "Bruk",
    "chip": "{{percent}}% rabatt",
    "remove": "Fjern kampanjekode",
    "errorGeneric": "Kunne ikke sjekke koden. Prøv igjen."
  },
  "errors": {
    "generic": "Kunne ikke starte kassen. Prøv igjen."
  },
  "totalUnavailable": "Priskatalog ikke tilgjengelig. Prøv igjen for å laste de nyeste prisene."
}
